import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

export interface UiSegmentedFilterOption {
  value: string;
  label: string;
  disabled?: boolean;
}

/**
 * Molécula: filtro de selección única con opciones visualmente agrupadas.
 * No contiene lógica de negocio; el padre controla el valor seleccionado.
 */
@Component({
  selector: 'ui-segmented-filter',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './segmented-filter.component.html',
  styleUrl: './segmented-filter.component.scss',
})
export class UiSegmentedFilterComponent {
  /** Nombre accesible del grupo, por ejemplo "Estatus". */
  readonly label = input.required<string>();

  readonly options = input<readonly UiSegmentedFilterOption[]>([]);
  readonly value = input('');
  readonly valueChange = output<string>();

  protected select(option: UiSegmentedFilterOption): void {
    if (option.disabled || option.value === this.value()) return;
    this.valueChange.emit(option.value);
  }
}
